import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-eye-link',
    templateUrl: './eye-link.component.html',
    styleUrls: ['./eye-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EyeLinkComponent {
  @Input() dataContext: string;

  onLinkClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
